/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2019-11-15 09:29:32
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-10-26 16:16:56
 */
let host = ''; // defaultNumber

let CONFIG = {
  projectStatus: 'dev',
  host: host,

  //测试地址
  // ajaxUrl: 'http://192.168.12.218/api/serv/',
  // fileUrl: 'http://192.168.12.218/api/file/',

  ajaxUrl: window.BASE_URL_API,
  fileUrl: window.BASE_URL_FILE,

  // mapKey: '866df9ce25ed3d99dff86f33468399b2',
  mapKey: '38963cf6e1d7092a3dfcf940b4979bd5',
  openidUrl: host + '/pay/openID.html',
  payUrl: host + '/pay/pay.html',

  companyName: '派诺', // 公司名称
  pullTimeDistance: 5000, // 充电流程轮询时间间隔
  // isCar: false, // 是否要车牌
  orderEndTime: 8, // 充电结束后，(默认,后台没设置的时候)几秒跳转
  messageTime: 60, // 短信时间(默认,后台没设置的时候)
  messageTimeText: '短信验证码5分钟有效，请勿重复获取', // 获取短信后的提示语
  chargingIsRecharge: true, // 充电中是否可以充值

  ajaxStatus: 0, // 请求后，后台返回的状态码
  ajaxStatus2: 0, // 请求后，后台返回的状态码
  domainName: '',
  fontSize: '',
  position: {
    lat: '',
    lng: '',
    city: ''
  },
  city: '',
  fileImg: "/api/file/",
  localKeyLogin: {
    loginInfo: 'loginInfo',
    qr: 'qr',
    recentCityArray: 'recentCityArray',
    myInfo: 'app_cdzUserindex',
    myMoney: 'myMoney',
    phoneInfo: 'phoneInfo',
    homeShowListStatus: 'homeShowListStatus',
  },
  // codeUrl: 'http://smartpiems.pmac.com.cn/zhouweiweiweb/get-code.html',  //这几个都是本地开发的时候用的
  // codeUrl: 'http://nwx.saas-prod.jwac.com.cn/get-code.html',
  codeUrl: 'http://wechat.saas.midoucd.com/get-code.html',
  version: '1.5.0',
  pileFixed: 3, // 价格保留多少位小数
  homeShowListStatus: false, // 主页是否一进去就显示列表，会改变
  bussType: { //发送验证码类型
    login: 101, // 登录/绑定
    updata: 103, // 修改信息
  }

};

if (window.appConfig && typeof window.appConfig === 'object') {
  CONFIG = Object.assign(CONFIG, window.appConfig);
}

export default CONFIG;